/**
 * @module store/promocodes/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetPromocodes, apiDeletePromocodes, apiSetPromocode } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Получеие страницы с промокодами
 *
 * @since Version 1.0.0
 */
const getPromocodes = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_PROMOCODES_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetPromocodes(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_PROMOCODES_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список промокодов.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_PROMOCODES_ASYNC.FAILURE);
  }
};


/**
 * Action: Delete promocodes
 *
 * @since Version 1.0.1
 */
const deletePromocodes = async ({ rootGetters }, promocodes) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeletePromocodes(userSession.accessToken.jwtToken, promocodes);
    } else {
      throw new Error('Неавторизованный пользователь не может удалять промокоды.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set promocode
 *
 * @since Version 1.0.3
 */
const setPromocode = async ({ rootGetters }, promocode) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetPromocode(userSession.accessToken.jwtToken, promocode);
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию о промокодах.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  deletePromocodes,
  getPromocodes,
  setPromocode,
};
